import gql from 'graphql-tag';
import { ConfigBootstrapSchema } from '../definitions/schemas';
import Interface from './Interface';

export enum ConfigurationKey {
  BLACKLISTED_ROOM_DOMAINS_KEY = 'blacklistedRoomDomains',
  BLACKLISTED_WORK_DOMAINS_KEY = 'blacklistedWorkDomains',
}

interface SearchConfiguration {
  // dynamic key-value configurations
  getConfiguration: { key: ConfigurationKey; value: any }[];
}

interface ConfigBootstrapData {
  config: ConfigBootstrapSchema;
}

export default class ConfigurationInterface extends Interface {
  public async search(key: ConfigurationKey[]) {
    const response = await this.query<SearchConfiguration>(
      () =>
        this.apolloService.executeQuery<SearchConfiguration>({
          query: gql`
            query getConfiguration($key: [ConfigurationKeyEnum!]!) {
              getConfiguration(key: $key) {
                key
                value
              }
            }
          `,
          variables: {
            key,
          },
        }),
      'Error getting app configuration'
    );

    return response.getConfiguration;
  }

  public async bootstrap() {
    const response = await this.query<ConfigBootstrapData>(
      () =>
        this.apolloService.executeQuery<ConfigBootstrapData>({
          query: gql`
            query config {
              config {
                apiUrl
                region
                equipExternalApiUrl
                oauthUrls {
                  azureUrl
                  googleUrl
                }
              }
            }
          `,
        }),
      'Error getting config bootstrap'
    );

    return response.config;
  }
}
